import React from "react";
import "./WorkCard.css";
import soft from "../utils/sounds/soft.mp3";
import useSound from "use-sound";
function WorkCard(props) {
  const[softSound]=useSound(soft);
  return (
    <>
      <div onClick={softSound} className="workCardMain">
        <div className="workCard">
          <a
            href={props.link}
            className="workCardLink"
            target="_blank"
            rel="noreferrer"
          >
            <img className="workCardImg" src={props.image} alt="Work"></img>
            <div className="workCardOverlay"></div>
            <h1 className="workCardTitle">{props.title}</h1>
            <p className="workCardContent">{props.content}</p>
          </a>
        </div>
      </div>
    </>
  );
}

export default WorkCard;
